const pricesDropDown = (section) => {
    const dropdown = section.querySelector('.sk-dropdown > .dropdown-options');
    if (!dropdown) return;
    const handleDropdownChange = (selected) => {
        const allDivs = section.querySelectorAll('.plans.layout-mobile .plans-col');
        allDivs.forEach(div => {
            const digitInClassName = div.className.match(/\d+/);
            if (digitInClassName && digitInClassName[0] === selected) {
                div.style.display = 'flex';
            } else if (digitInClassName && digitInClassName[0] === '0') {
                div.style.display = 'flex';
            } else {
                div.style.display = 'none';
            }
        });
    };

    const initialSelected = dropdown.value;
    handleDropdownChange(initialSelected);

    dropdown.addEventListener('change', ({ target }) => {
        const selected = target.value;
        handleDropdownChange(selected);
    });
};

export default pricesDropDown;



// WEBPACK FOOTER //
// ./scripts/modules/pricesDropdown.js